import SERVICES from './services'
export const services = SERVICES



// WEBPACK FOOTER //
// ./src/vuex/api/index.js